












































import { Component, Vue } from 'vue-property-decorator'
import RoleSelection from './RoleSelection.modal.vue'

@Component({ components: { RoleSelection } })
export default class Home extends Vue {
  get isAuthenticated () {
    return this.$store.getters.isAuthenticated
  }

  get isAssignable () {
    return this.$store.getters.getUserIsAssignable
  }

  async mounted () {
    if ((process.env.FORCE_ROLE_SELECTION || '').toUpperCase() === 'TRUE') {
      await this.$store.dispatch('checkUserIsAssignable').then((isAssignable: any) => {
        if (isAssignable) {
          const modal = this.$refs.roleSelection as any
          modal.$bvModal.show('role-selection-modal')
          // log modal shown event
          this.$store.dispatch('addEvent', { description: 'Role slection modal shown', data: null, title: 'Role slection modal shown', eventType: 12, userAgent: navigator.userAgent, product: null, market: { key: this.$store.getters.getSelectedMarket }, trackingKey: null })
        }
      })
    }
    const _browserDetect = (this as any).$browserDetect
    if (_browserDetect.isIE && _browserDetect.meta.version === '11' && this.$store.getters.isAuthenticated) {
      const _msgNode = this.$createElement('div', [
        this.$createElement('p', { class: ['mb-1'] }, ['Unforunately this browser is not supported by the Value Platform.']),
        this.$createElement('p', { class: ['mb-1'] }, ['Please use an alternative browser.']),
        this.$createElement('p', { class: ['m-0'] }, ['For the best experience we recommend Google Chrome.'])
      ])
      this.$bvModal.msgBoxOk([_msgNode], {
        size: 'sm',
        buttonSize: 'md',
        okTitle: 'OK',
        titleClass: 'w-100 text-center',
        okVariant: 'default',
        footerClass: 'p-2 text-center',
        bodyClass: 'text-center',
        noCloseOnBackdrop: true,
        noCloseOnEscape: true,
        hideHeaderClose: true,
        title: 'Browser not supported',
        centered: true
      }).then(() => {
        this.$router.push({ name: 'logout' })
      })
    }
  }
}
